import {oxgGetLang} from './get-lang'

export const oxgRemoveUfsFromContainer = (container) => {
  let userFeedbackMessages = container.querySelectorAll('.uf-element')
  if (userFeedbackMessages) {
    Array.from(userFeedbackMessages).forEach(message => { message.remove() })
  }
}

export const oxgCreateUf = (args)=> {
  let lang = oxgGetLang()
  let container = args.container ? args.container : null
  let returnElement = args.return ? args.return : false

  let message = null

  if (args.messageDe && ['de-DE', 'de', 'de-AT', 'de-CH', 'de-LI', 'de-LU'].includes(lang)) {
    message = args.messageDe && typeof(args.messageDe) == 'string' && message != '' ? args.messageDe: null
  } else {
    message = args.message && typeof(args.message) == 'string' && message != '' ? args.message: null
  }
  if ( !message ) {
    console.error('message is empty or not of type string')
    return
  }

  let append = args.append ? args.append : true
  let theStyle = args.style && typeof(args.style) == 'string' ? args.style : 'info'
  let icon = args.icon && typeof(args.icon) == 'string' ? args.icon: null
  let format = args.format ? args.format : null
  let tag = args.tag ? args.tag : 'div'
  let signal = args.signal && args.signal == 'false' ? false : true
  let id = args.id && typeof(id) == 'string' ? args.id : null
  let classes = args.classes ? args.classes : null
  let iconClasses = args.iconClasses ? args.iconClasses : null
  let textClasses = args.textClasses ? args.textClasses : null

  const allowedTags =  ['div', 'p', 'span', 'li']
  const allowedFormats = ['text', 'box', 'default']
  const allowedStyles = ['default', 'note', 'success', 'danger', 'warning', 'info']

  if (format && !allowedFormats.includes(format)) { format = 'text' }
  if (tag && !allowedTags.includes(tag)) { tag = 'div' }
  if (classes) { if(typeof(classes) != 'string' && !Array.isArray(classes)) { classes = null } }
  if (textClasses) { if(typeof(textClasses) != 'string' && typeof(textClasses) != 'array') { textClasses = null } }
  if (iconClasses) { if(typeof(iconClasses) != 'string' && typeof(iconClasses) != 'array') { iconClasses = null } }

  let userFeedback = document.createElement(tag)
  userFeedback.classList.add('uf-element')

  //box or text
  if (format == 'text' || format == 'default') { 
    userFeedback.classList.add('uf-text', 'tc-' + theStyle)
  } else {
    userFeedback.classList.add('uf-box', 'style-' + theStyle)
  }
  if (classes) { 
    if (!Array.isArray(classes)) { classes = [classes] }
    classes.forEach(theClass => { userFeedback.classList.add(theClass) })
  }

  //id
  id ? userFeedback.setAttribute('id', id) : null

  //icon
  if(icon) {
    let theIcon = document.createElement('span')
    theIcon.classList.add('icon-' + icon, 'inline-icon', 'm-xxs-right')
    if (iconClasses) { 
      if (!Array.isArray(iconClasses)) { iconClasses = [iconClasses] }
      iconClasses.forEach(theClass => { theIcon.classList.add(theClass) })
    }
    userFeedback.appendChild(theIcon)
  }

  //text
  let text = document.createElement('span')
  text.classList.add('text')
  text.innerText = message
  if (textClasses) { 
    if (!Array.isArray(textClasses)) { textClasses = [textClasses] }
    textClasses.forEach(theClass => { text.classList.add(theClass) })
  }
  userFeedback.appendChild(text)

  //signal
  if(signal) {
    if (format == 'text') {
      userFeedback.classList.add('blink')
    } else {
      let signal = document.createElement('div')
      signal.classList.add('signal', 'blink')
      signal.setAttribute('aria-hidden', 'true')
      userFeedback.appendChild(signal)
    }
  }

  if (append) container.appendChild(userFeedback)
  if (returnElement) { return userFeedback }
}